import localforage from "localforage";
import {saveNewWorkday} from "../../api/workdays";
import {updateActivity} from "../../api/activities";
import {writeLog} from "../../utils/logging";
import {writeTrackLog} from "../../utils/tracking";
import {isOnline} from "../../utils/online";
import FileCache from "@/utils/file";

export default {
  overrideLocal(state, value) {
    localforage.setItem('overrideLocal', !!value);
    state.overrideLocal = !!value;
  },

  setOnline(state) {
    console.log('___ONLINE___')
    state.online = true;
    window.events.$emit('updateVitals')
  },

  setOffline(state) {
    console.log('___OFFLINE___')
    state.online = false;
    window.events.$emit('updateVitals')
  },

  sendFCMTokenToBackend(state, token) {
    state.fcmToken = token;

    localforage.setItem('fcmToken', token);
  },

  setFullscreen(state, payload) {
    state.fullscreen = payload;
  },

  syncOnline(state, payload) {
    state.syncOnline = payload;
  },

  setChecked(state, payload) {
    state.checked = true;
    state.afterChecked = payload;
  },

  setBatteryLevel(state, payload) {
    state.batteryLevel = payload;
  },

  setBatteryCharging(state, payload) {
    state.batteryCharging = payload;
  },

  clearChecked(state) {
    state.checked = false;
    state.afterChecked = null;
  },

  togglePinVisible(state) {
    state.pinVisible = !state.pinVisible;
    localforage.setItem('pinVisible', state.pinVisible);
  },

  setPinVisible(state, payload) {
    console.log('Store::setPinVisible', payload)
    state.pinVisible = payload;
    localforage.setItem('pinVisible', state.pinVisible);
  },

  toggleDarkMode(state) {
    state.darkMode = !state.darkMode;
    localforage.setItem('darkMode', state.darkMode);
  },

  setDarkMode(state, payload) {
    console.log('Store::setDarkMode', payload)
    state.darkMode = payload;
    localforage.setItem('darkMode', state.darkMode);
  },

  setError(state, error) {
    state.error = error;
  },

  clearError(state) {
    state.error = null;
  },

  setSuccess(state, success) {
    state.success = success;
  },

  setToken(state, token) {
    state.token = token;
  },

  clearToken(state) {
    state.token = null;
    localforage.removeItem('token');
    localStorage.removeItem('token');
  },

  setDevices(state, devices) {
    state.devices = devices;
  },

  clearDevices(state) {
    state.devices = [];
  },

  setCurrentDevice(state, device) {
    state.currentDevice = device;

    if (device && device.debug) state.debug = device.debug;
    if (device && device.enable_tracking) state.enableTracking = device.enable_tracking;
  },

  clearCurrentDevice(state) {
    state.currentDevice = null;
    localforage.clear();
  },

  setLanguage(state, payload) {
    state.language = payload;

    localforage.setItem('language', payload)
  },

  setLocations(state, locations) {
    state.locations = locations;

    const l = locations.length;

    for (let i = 0; i < l; i++) {
      let location = locations[i];

      window.locationStore.setItem(location.id.toString(), location);
    }
  },

  clearLocations(state) {
    state.locations = null;
    window.locationStore.clear();
  },

  setCurrentLocation(state, location) {
    state.currentLocation = location;
  },

  clearCurrentLocation(state) {
    state.currentLocation = null;
  },

  setEmployee(state, employees) {
    if (state.employees === null || state.employees === undefined) state.employees = [];
    state.employees.push(employees);
  },

  setEmployees(state, employees) {
    state.employees = employees;
  },

  storeEmployeesOffline(state, payload) {
    const l = payload && payload.length ? payload.length : 0;

    for (let i = 0; i < l; i++) {
      let employee = payload[i];
      window.employeeStore.setItem(employee.id.toString(), employee);
    }
  },

  clearEmployees(state) {
    state.employees = null;
    window.employeeStore.clear();
  },

  setCurrentEmployee(state, employee) {
    state.currentEmployee = employee;
  },

  clearCurrentEmployee(state) {
    state.currentEmployee = null;
    state.currentEmployeeActivities = null;
  },

  setTeams(state, teams) {
    state.teams = teams;
  },

  storeTeamsOffline(state, payload) {
    const l = payload && payload.length ? payload.length : 0;

    for (let i = 0; i < l; i++) {
      let team = payload[i];
      window.teamStore.setItem(team.id.toString(), team);
    }
  },

  clearTeams(state) {
    state.teams = null;
    window.teamStore.clear();
  },

  setActivities(state, activities) {
    state.activities = activities;
  },

  storeActivitiesOffline(state, payload) {
    const l = payload && payload.length ? payload.length : 0;

    for (let i = 0; i < l; i++) {
      let activity = payload[i];

      window.activityStore.setItem(activity.id.toString(), activity);
    }
  },

  clearActivities(state) {
    state.activities = null;
    window.activityStore.clear();
  },

  setRows(state, rows) {
    state.rows = rows
  },

  storeRowsOffline(state, payload) {
    const l = payload && payload.length ? payload.length : 0;

    for (let i = 0; i < l; i++) {
      let row = payload[i];

      window.rowStore.setItem(row.id.toString(), row)
    }
  },

  clearRows(state) {
    state.rows = null;
    window.rowStore.clear();
  },

  setPackagings(state, packagings) {
    state.packagings = packagings;
  },

  storePackagingsOffline(state, payload) {
    window.packagingsStore.clear();

    const l = payload && payload.length ? payload.length : 0;

    for (let i = 0; i < l; i++) {
      let packaging = payload[i];

      if (packaging.image_path !== null && packaging.image_path !== undefined) {
        let img = new Image();
        img.src = packaging.image_path;
      }

      window.packagingsStore.setItem(packaging.id.toString(), packaging);
    }
  },

  clearPackagings(state) {
    state.packagings = null;
    window.packagingsStore.clear();
  },

  setPercentages(state, percentages) {
    state.percentages = percentages;
  },

  storePercentagesOffline(state, payload) {
    window.percentagesStore.clear();

    const l = payload && payload.length ? payload.length : 0;

    for (let i = 0; i < l; i++) {
      let percentage = payload[i];

      window.percentagesStore.setItem(percentage.id.toString(), percentage);
    }
  },

  clearPercentages(state) {
    state.percentages = null;
    window.percentagesStore.clear();
  },


  setWorkdays(state, workdays) {
    state.workdays = workdays;
  },

  deleteWorkday(state, payload) {
    const entry = state.workdays.find(item => item.id === payload.id);

    if (!entry) return;

    const index = state.workdays.indexOf(entry);

    if (index > -1) state.workdays.splice(index, 1);
  },

  storeWorkdaysOffline(state, payload) {
    const l = payload && payload.length ? payload.length : 0;

    for (let i = 0; i < l; i++) {
      let workday = payload[i];

      window.workdayStore.setItem(workday.id.toString(), workday)
    }

  },

  clearWorkdays(state) {
    state.workdays = null;
    window.workdayStore.clear();
  },

  createWorkday(state, workday) {
    if (state.workdays === null || state.workdays === undefined) state.workdays = []

    state.workdays.push(workday);
    window.workdayStore.setItem(workday.id, workday);

    if (!isOnline()) return;

    const store = this;
    saveNewWorkday(workday, store);
  },

  setTimesheetEntries(state, entries) {
    state.timesheetEntries = entries;
  },

  deleteTimesheetEntry(state, payload) {
    const entry = state.timesheetEntries.find(item => item.id === payload.id);

    if (!entry) return;

    const index = state.timesheetEntries.indexOf(entry);

    if (index > -1) state.timesheetEntries.splice(index, 1);
  },

  clearTimesheetEntries(state) {
    state.timesheetEntries = null;
    window.timesheetStore.clear();
  },

  storeActivity(state, activity) {
    if (process.env.NODE_ENV === 'development') console.log('storeActivity', activity, isOnline(), state.syncOnline);

    if (!state.timesheetEntries) state.timesheetEntries = [];

    state.timesheetEntries.push(activity);
    window.timesheetStore.setItem(activity.id.toString(), activity);

    if (isOnline() && state.syncOnline) {
      const store = this;
      updateActivity(activity, store);
    }
  },

  updateActivity(state, payload) {
    if (state.enableTracking) writeTrackLog('Update activity local: ' + JSON.stringify(payload));

    const activity = state.timesheetEntries.find(entry => entry.id === payload.id);

    if (payload.employee_id) {
      activity.employee_id = payload.employee_id;
      activity.synced = false;
    }

    if (payload.team_id) {
      activity.team_id = payload.team_id;
      activity.synced = false;
    }

    if (payload.team_name) {
      activity.team_name = payload.team_name;
      activity.synced = false;
    }

    if (payload.packaging) {
      activity.packaging = payload.packaging;
      activity.synced = false;
    }

    if (payload.amount) {
      activity.amount = payload.amount;
      activity.synced = false;
    }

    if (payload.row_id) {
      activity.row_id = payload.row_id;
      activity.synced = false;
    }

    if (payload.row) {
      activity.row = payload.row;
      activity.synced = false;
    }

    if (payload.row_status) {
      activity.row_status = payload.row_status;
      activity.synced = false;
    }

    if (payload.row_percentage) {
      activity.row_percentage = payload.row_percentage;
      activity.synced = false;
    }

    if (payload.start) {
      activity.start = payload.start;
      activity.synced = false;
    }

    if (payload.end) {
      activity.end = payload.end;
      activity.synced = false;
    }

    if (payload.on_hold === true) {
      activity.on_hold = payload.on_hold;
      activity.synced = false;
    } else if (payload.on_hold === false) {
      activity.on_hold = false;
      activity.synced = false;
    }

    window.timesheetStore.setItem(activity.id.toString(), activity);

    if (state.enableTracking) writeTrackLog('Updated local activity ' + activity.id.toString() + ':' + JSON.stringify(activity));

    if (isOnline() && state.syncOnline) {
      const store = this;
      updateActivity(activity, store);
    }
  },

  updateTimesheetEntry(state, payload) {
    if (state.enableTracking) writeTrackLog('Update activity local: ' + JSON.stringify(payload));

    const activity = state.timesheetEntries.find(entry => entry.id === payload.id);

    console.log('updateTimesheetEntry', payload, activity)

    for (let key in payload) {
      if (payload.hasOwnProperty(key) && activity.hasOwnProperty(key)) activity[key] = payload[key];
    }

    activity.synced = false;

    if (isOnline() && state.syncOnline) {
      const store = this;
      updateActivity(activity, store);
    }
  },

  cancelActivity(state, activity) {
    if (this.getters.debug) writeLog("removing activity: " + JSON.stringify(activity));
    if (state.enableTracking) writeTrackLog('Cancel activity' + JSON.stringify(activity));

    const index = state.timesheetEntries.indexOf(activity);

    state.timesheetEntries.splice(index, 1);
    window.timesheetStore.removeItem(activity.id.toString());

    if (activity.external_id) window.timesheetStore.removeItem(activity.external_id.toString());
    if (activity.old_id) window.timesheetStore.removeItem(activity.old_id.toString());
  },

  setActivityOrder(state, newOrder) {
    state.activityOrder = newOrder;
    localforage.setItem('activity_order', newOrder);
  },

  setRowsOrder(state, newOrder) {
    state.rowsOrder = newOrder;
    localforage.setItem('rows_order', newOrder);
  },

  setTeamsOrder(state, newOrder) {
    state.teamsOrder = newOrder;
    localforage.setItem('teams_order', newOrder);
  },

  clearActivityOrder(state) {
    localforage.removeItem('activity_order');

    state.activityOrder = state.currentDevice.activity_order;
    localforage.setItem('activity_order', state.currentDevice.activityOrder);
  },

  clearRowsOrder(state) {
    localforage.removeItem('rows_order');

    state.rowsOrder = state.currentDevice.rows_order;
    localforage.setItem('rows_order', state.currentDevice.rows_order);
  },

  clearTeamsOrder(state) {
    localforage.removeItem('teams_order');

    state.teamsOrder = state.currentDevice.teams_order;
    localforage.setItem('teams_order', state.currentDevice.teams_order);
  },

  toggleRowsAsButtons(state) {
    state.rowsAsButtons = !state.rowsAsButtons;
    localforage.setItem('rowsAsButtons', state.rowsAsButtons);
  },

  setRowsAsButtons(state, payload) {
    console.log('Store::setRowsAsButtons', payload)
    state.rowsAsButtons = payload;
    localforage.setItem('rowsAsButtons', state.rowsAsButtons);
  },

  toggleTeamsAsButtons(state) {
    state.teamsAsButtons = !state.teamsAsButtons;
    localforage.setItem('teamsAsButtons', state.teamsAsButtons);
  },

  setTeamsAsButtons(state, payload) {
    state.teamsAsButtons = payload;
    localforage.setItem('teamsAsButtons', state.teamsAsButtons);
  },
}
